module.exports = __webpack_public_path__ + "img/mmi-about-photo-team-trista.59668574.png";